/* eslint-disable no-restricted-syntax,consistent-return */
import { isEmpty } from 'lodash';
import { mapGetters, mapState } from 'vuex';
import {
  COLOR_MAP,
  getColorForPalletteCandidate,
} from '@/components/pages/page-election-map-new/election-map/election-map-constants';
import Contract from '@/models/contract';
import { getLeadingTradedContract } from '@/utils/helpers';

export default {
  data() {
    return {
      ready: false,
      showTooltip: false,
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop', 'isLayoutMobile']),
    ...mapState('market', ['mapStateDataSenate', 'marketMapTooltipVisible']),
    ga2MarketData() {
      return this.mapStateDataSenate.GA2 || {};
    },
    classModifiers() {
      return {
        'election-map-special': true,
        'election-map-special--tooltip-visible': this.marketMapTooltipVisible,
      };
    },
    legendStyleModifiers() {
      return {
        background: this.color,
      };
    },
    color() {
      return this.pallette.color;
    },
    targetContract() {
      return getLeadingTradedContract(this.ga2MarketData.contracts || []);
    },
    targetContractInstance() {
      return new Contract(this.targetContract || {});
    },
    pallette() {
      if (!this.targetContract) {
        return COLOR_MAP.GRAY[1];
      }

      const pallette = getColorForPalletteCandidate(this.targetContract.contractName);
      const factor = pallette[0].from + this.targetContract.lastTradePrice;
      for (const item of pallette) {
        if (factor <= item.to) {
          return item;
        }
      }

      return pallette[pallette.length - 1];
    },
  },
  watch: {
    mapStateDataSenate: {
      handler: 'mapStateDataHandler',
      immediate: true,
    },
  },
  methods: {
    onClick() {
      if (this.isLayoutMobile) {
        const marketId = this.ga2MarketData.marketId;
        if (marketId) {
          window.location.href = `https://www.predictit.org/markets/detail/${marketId}`;
        }
      }
    },
    onMouseEnter() {
      this.showTooltip = true;
    },
    onMouseLeave() {
      this.showTooltip = false;
    },
    mapStateDataHandler(value) {
      if (!isEmpty(value)) {
        this.ready = true;
      }
    },
  },
};
